import React from "react";
import { useSearchParams } from "react-router-dom";

import RatingPage from "./components/RatingPage";
import CommentPage from "./components/CommentPage";
import ResultPage from "./components/ResultPage";

import { useTokenValidation } from "./hooks/useTokenValidation";
import { useQrTracking } from "./hooks/useQrTracking";
import { useFeedbackFlow } from "./hooks/useFeedbackFlow";

import "./App.css";

function App() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const { isValidToken, isLoading } = useTokenValidation(token);

  useQrTracking(token, isValidToken);

  const {
    step,
    comment, setComment,
    email, setEmail,
    response,
    isSubmitting,
    handleRatingClick,
    handleSubmitComment,
    handleGoogleClick,
  } = useFeedbackFlow(token, isValidToken);

  if (isLoading || isValidToken === null) {
    return (
      <div className="container">
        <div className="card">Loading...</div>
      </div>
    );
  }

  if (!token || !isValidToken) {
    return (
      <div className="container">
        <div className="card">Invalid or expired QR code</div>
      </div>
    );
  }

  if (step === "RATING") return <RatingPage onSelect={handleRatingClick} />;

  if (step === "COMMENT") {
    return (
      <CommentPage
        comment={comment}
        setComment={setComment}
        email={email}
        setEmail={setEmail}
        onSubmit={handleSubmitComment}
        isSubmitting={isSubmitting}
      />
    );
  }

  if (step === "RESULT") {
    return <ResultPage response={response} onGoogleClick={handleGoogleClick} />;
  }

  return null;
}

export default App;